export const PRIORITY_BUTTON_TEST_ID =
	'software-board.board-container.board.card-container.card.priority-field.button';
